import { render, staticRenderFns } from "./ExpandablePanel.vue?vue&type=template&id=1807d27a&scoped=true&"
import script from "./ExpandablePanel.vue?vue&type=script&lang=js&"
export * from "./ExpandablePanel.vue?vue&type=script&lang=js&"
import style0 from "./ExpandablePanel.vue?vue&type=style&index=0&id=1807d27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807d27a",
  null
  
)

export default component.exports